<template>
  <b-modal
    id="product-form-modal"
    centered
    size="large"
    hide-header
    hide-footer
  >
    <div class="product-form gallery-modal px-1 pt-2">
      <b-tabs v-model="tabIndex">
        <!-- tab 1 -->
        <b-tab>
          <template #title>
            <span class="icon">
              <inline-svg
                :src="require(`@/assets/images/icons/dashboard/catalog.svg`)"
              />
            </span>
            <span class="text">بيانات الخدمة / المنتج</span>
          </template>

          <div class="row pt-2 mt-1">
            <div class="col-md-6 mb-2">
              <label class="d-block">الخدمات</label>
              <div class="d-flex">
                <b-input-group>
                  <b-input-group-prepend is-text>
                    <inline-svg
                      :src="
                        require('@/assets/images/icons/dashboard/layer-2.svg')
                      "
                    />
                  </b-input-group-prepend>
                  <b-form-select :value="null" :options="options" />
                </b-input-group>
                <button class="btn btn--outlined-gray ml-1">
                  <img
                    :src="
                      require(`@/assets/images/icons/dashboard/add-sector.svg`)
                    "
                    width="20"
                  />
                </button>
              </div>
            </div>
            <div class="col-md-6 mb-2">
              <label class="d-block">الاقسام</label>
              <div class="d-flex">
                <b-input-group>
                  <b-input-group-prepend is-text>
                    <inline-svg
                      :src="
                        require('@/assets/images/icons/dashboard/layer-2.svg')
                      "
                    />
                  </b-input-group-prepend>
                  <b-form-select :value="null" :options="options" />
                </b-input-group>
                <button class="btn btn--outlined-gray ml-1">
                  <img
                    :src="
                      require(`@/assets/images/icons/dashboard/add-sector.svg`)
                    "
                    width="20"
                  />
                </button>
              </div>
            </div>
            <div class="col-md-6 mb-2">
              <label class="d-block">كود الخدمة</label>
              <b-form-input value="ZS52652" disabled />
            </div>
            <div class="col-md-6 mb-2">
              <label class="d-block">تحسينات SEO</label>
              <b-form-input placeholder="عنوان صفحة المنتج" />
            </div>
            <div class="col-12">
              <b-form-tags
                v-model="tags"
                class="mb-2 py-1"
                placeholder="أضف نص دلالي لمحركات البحث"
                addButtonText="اضافة"
              />
            </div>
            <div class="col-md-6 mb-2">
              <label class="d-block">اسم الخدمة بالعربي</label>
              <b-form-input placeholder="اسم الخدمة بالعربي" />
            </div>
            <div class="col-md-6 mb-2">
              <label class="d-block">اسم الخدمة بالانجليزي</label>
              <b-form-input placeholder="اسم الخدمة بالانجليزي" />
            </div>
            <div class="col-md-6 mb-2">
              <label class="d-block">الوصف عربي</label>
              <quill-editor :options="snowOption" class="rtl-editor" />
            </div>
            <div class="col-md-6 mb-2">
              <label class="d-block">الوصف انجليزي</label>
              <quill-editor :options="snowOption" class="ltr-editor" />
            </div>
            <div class="col-12 mb-2">
              <button
                class="btn btn--light-green btn-lg px-1 mb-1"
                @click="$bvModal.show('gallery-modal')"
              >
                <inline-svg
                  :src="
                    require('@/assets/images/icons/dashboard/folder-add.svg')
                  "
                  class="mr-1"
                />
                مكتبة وسائط المتجر
              </button>
              <draggable
                v-model="gallery"
                class="gallery-list"
                style="direction: ltr"
              >
                <div
                  v-for="(image, index) in gallery"
                  :key="index"
                  class="gallery-list__item"
                >
                  <img
                    :src="`https://picsum.photos/100/100?random=${image}`"
                    width="200"
                    class="gallery-list__item__img"
                  />
                  <span
                    class="gallery-list__item__icon"
                    @click="gallery.splice(index, 1)"
                  >
                    <feather-icon icon="XIcon" />
                  </span>
                  <span class="gallery-list__item__icon green">{{
                    index + 1
                  }}</span>
                  <span class="gallery-list__item__icon green cursor-move">
                    <feather-icon icon="MoveIcon" />
                  </span>
                </div>
              </draggable>
            </div>
          </div>
          <div class="modal-actions">
            <button class="btn px-4 btn--gradient-orange" @click="hideModal">
              تعديل
            </button>
            <button class="btn px-4 btn--gradient-green" @click="hideModal">
              حفظ بيانات المنتج
            </button>
            <button class="btn px-4 btn--gray ml-1" @click="hideModal">
              الغاء
            </button>
          </div>
        </b-tab>
        <!-- end tab 1 -->

        <!-- tab 2 -->
        <b-tab class="step-2">
          <template #title>
            <span class="icon">
              <inline-svg
                :src="
                  require(`@/assets/images/icons/dashboard/settings-price.svg`)
                "
              />
            </span>
            <span class="text">الاعدادات والتسعير</span>
          </template>

          <div class="row pt-2 mt-1">
            <div class="col-12">
              <label class="d-block mb-1 h5">التسعير</label>
              <div class="row">
                <div class="col-md-6 mb-2">
                  <b-input-group prepend="سعر الكلفة" append="RS">
                    <b-form-input placeholder="00" class="text-center" />
                  </b-input-group>
                </div>
                <div class="col-md-6 mb-2">
                  <b-input-group prepend="سعر البيع" append="RS">
                    <b-form-input placeholder="00" class="text-center" />
                  </b-input-group>
                </div>
                <div class="col-md-6 mb-2">
                  <b-input-group prepend="السعر المخفض">
                    <b-form-input placeholder="00" class="text-center" />
                  </b-input-group>
                </div>
                <div class="col-md-6 mb-2">
                  <b-input-group prepend="نهاية التخفيض">
                    <b-form-datepicker
                      class="pl-1"
                      placeholder="نهاية التخفيض"
                      :date-format-options="{
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric',
                      }"
                      :locale="$i18n.locale"
                    />
                  </b-input-group>
                </div>
              </div>
            </div>
            <div class="col-12">
              <label class="d-block mb-1 h5">الكمية</label>
              <div class="checkbox-container gray-bg mb-1 d-inline-flex">
                <span class="text-nowrap">الكمية محددة</span>
                <b-form-input placeholder="000" :disabled="!fixedQuantity" />
                <b-form-checkbox v-model="fixedQuantity"></b-form-checkbox>
              </div>
              <div class="row" :class="{ 'disabled-box': !fixedQuantity }">
                <div class="col-md-6 mb-2">
                  <b-input-group prepend="أقل كمية للعميل">
                    <b-form-input placeholder="00" class="text-center" />
                  </b-input-group>
                </div>
                <div class="col-md-6 mb-2">
                  <b-input-group prepend="أعلى كمية للعميل">
                    <b-form-input placeholder="00" class="text-center" />
                  </b-input-group>
                </div>
                <div class="col-md-6 mb-2">
                  <b-input-group prepend="أقل كمية مخزون" append="RS">
                    <b-form-input placeholder="00" class="text-center" />
                  </b-input-group>
                </div>
                <div class="col-md-6 mb-2">
                  <b-input-group prepend="رمز التخزين">
                    <b-form-input placeholder="00" class="text-center" />
                  </b-input-group>
                </div>
              </div>
            </div>
            <div class="col-12">
              <label class="d-block mb-1 h5">الشحن</label>
              <div class="checkbox-container gray-bg mb-1 d-inline-flex">
                <span class="checkbox-container__label"
                  >الخدمة / المنتج يتطلب شحن</span
                >
                <b-form-checkbox v-model="requireShipping"></b-form-checkbox>
              </div>
              <div class="row" :class="{ 'disabled-box': !requireShipping }">
                <div class="col-md-6 mb-2">
                  <b-input-group prepend="نوع الشحن">
                    <b-form-select :options="options" :value="null" />
                  </b-input-group>
                </div>
                <div class="col-md-6 mb-2">
                  <div class="d-flex">
                    <b-input-group prepend="إضافة شحن">
                      <b-form-select :value="null" :options="options" />
                    </b-input-group>
                    <button class="btn btn--outlined-gray ml-1">
                      <feather-icon
                        icon="PlusCircleIcon"
                        color="#2E5D67"
                        size="20"
                      />
                    </button>
                  </div>
                </div>
                <div class="col-md-6 mb-2">
                  <b-input-group prepend="الوزن الكلي">
                    <b-form-input placeholder="00" class="text-center" />
                    <b-input-group-append>
                      <b-form-select :value="null" :options="options" />
                    </b-input-group-append>
                  </b-input-group>
                </div>
                <div class="col-md-6 mb-2">
                  <b-input-group prepend="الحجم الكلي" append="سم">
                    <b-form-input placeholder="00" class="text-center" />
                  </b-input-group>
                </div>
                <div class="col-md-4 mb-2">
                  <b-input-group prepend="العرض" append="سم">
                    <b-form-input placeholder="00" class="text-center" />
                  </b-input-group>
                </div>
                <div class="col-md-4 mb-2">
                  <b-input-group prepend="الطول" append="سم">
                    <b-form-input placeholder="00" class="text-center" />
                  </b-input-group>
                </div>
                <div class="col-md-4 mb-2">
                  <b-input-group prepend="الارتفاع" append="سم">
                    <b-form-input placeholder="00" class="text-center" />
                  </b-input-group>
                </div>
              </div>
            </div>
            <div class="col-12">
              <label class="d-block mb-1 h5">خيارات الدفع</label>
              <div class="row">
                <div class="col-md-3 mb-2">
                  <b-form-radio name="payment-r" value="1">
                    الدفع من خلال المنصة
                  </b-form-radio>
                </div>
                <div class="col-md-3 mb-2">
                  <b-form-radio name="payment-r" value="2">
                    الدفع للمزود مباشرة
                  </b-form-radio>
                </div>
                <div class="col-md-3 mb-2">
                  <b-form-radio name="payment-r" value="3">
                    الدفع للمنصة والمزود
                  </b-form-radio>
                </div>
              </div>
              <div class="row align-items-center">
                <div class="col-md-3 mb-2">
                  <b-form-checkbox name="payment-c" value="1">
                    الدفع من خلال المنصة
                  </b-form-checkbox>
                </div>
                <div class="col-md-3 mb-2">
                  <b-form-checkbox name="payment-c" value="2">
                    الدفع للمزود مباشرة
                  </b-form-checkbox>
                </div>
                <div class="col mb-2 d-flex align-items-center">
                  دفعة أولى
                  <b-form-input
                    placeholder="00"
                    class="text-center w-auto px-10 mx-1"
                    style="max-width: 50px"
                  />
                  % والباقي عند الاستلام / التنفيذ
                </div>
              </div>
            </div>
          </div>

          <div class="modal-actions pt-1">
            <button class="btn px-4 btn--gradient-orange" @click="hideModal">
              تعديل
            </button>
            <button class="btn px-4 btn--gradient-green" @click="hideModal">
              حفظ بيانات المنتج
            </button>
            <button class="btn px-4 btn--gray ml-1" @click="hideModal">
              الغاء
            </button>
          </div>
        </b-tab>
        <!-- end tab 2 -->

        <!-- tab 3 -->
        <b-tab>
          <template #title>
            <span class="icon">
              <inline-svg
                :src="require(`@/assets/images/icons/dashboard/options.svg`)"
              />
            </span>
            <span class="text">خيارات أخرى</span>
          </template>

          <div class="row pt-2 mt-1">
            <div class="col-md-4 mb-2">
              <div class="checkbox-container gray-bg mb-1">
                <span class="checkbox-container__label"
                  >فتح تعليقات العملاء</span
                >
                <b-form-checkbox></b-form-checkbox>
              </div>
            </div>
            <div class="col-md-4 mb-2">
              <div class="checkbox-container gray-white mb-1">
                <span class="checkbox-container__label"
                  >الخدمة مخصصة لذوي الاعاقة</span
                >
                <b-form-checkbox></b-form-checkbox>
              </div>
            </div>
            <div class="col-md-4 mb-2">
              <div class="checkbox-container gray-bg mb-1">
                <span class="checkbox-container__label"
                  >الخدمة غير خاضعة لعروض المنصة</span
                >
                <b-form-checkbox></b-form-checkbox>
              </div>
            </div>
            <div class="col-md-3 mb-2">
              <div class="checkbox-container gray-bg">
                <span class="checkbox-container__label">تفعيل نطاق الخدمة</span>
                <b-form-checkbox v-model="activeGeoService"></b-form-checkbox>
              </div>
            </div>
            <div class="col mb-2 text-green">
              تفعيل نطاق الخدمة يعني أن المزود بإمكانه تقديم خدماته للنطاقات
              الجغرافية التي يرغب بتحديدها والتي بناء عليه ستظهر خدماته للعملاء
              .. في النطاقات الجغرافية المحددة
            </div>
            <div class="col-12 mb-2">
              <label class="d-block mb-1 h5">اختر دولة / دول</label>
              <v-select
                v-model="selected"
                :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'"
                multiple
                label="text"
                :options="options"
                :disabled="!activeGeoService"
                placeholder="اختر دولة / دول"
              />
            </div>
            <div class="col-12 mb-2">
              <label class="d-block mb-1 h5">اختر مدينة / مدن</label>
              <v-select
                v-model="selected2"
                :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'"
                multiple
                label="text"
                :options="options"
                :disabled="!activeGeoService"
                placeholder="اختر مدينة / مدن"
              />
            </div>
            <div class="col-md-4 mb-2 d-flex">
              <div class="checkbox-container gray-bg flex-grow-1">
                <span class="checkbox-container__label"
                  >تفعيل مسؤول الخدمة</span
                >
                <b-form-checkbox v-model="activeAdmin"></b-form-checkbox>
              </div>
              <button class="btn btn--outlined-gray ml-1">
                <feather-icon icon="EyeIcon" color="#2E5D67" size="20" />
              </button>
            </div>
            <div class="col-md-8 mb-2 text-green">
              يتيح تفعيل خيار مسؤول الخدمة .. ظهور بيانات هذا المسؤول عن هذه
              الخدمة في المتجر لكي يتمكن العملاء التعامل مع المسؤول بشكل مباشر
            </div>
            <div class="col-12">
              <div class="row" :class="{ 'disabled-box': !activeAdmin }">
                <div class="col-md-4 mb-2">
                  <b-input-group prepend="الاسم">
                    <b-form-input />
                  </b-input-group>
                </div>
                <div class="col-md-4 mb-2">
                  <b-input-group prepend="الايميل">
                    <b-form-input />
                  </b-input-group>
                </div>
                <div class="col-md-4 mb-2">
                  <b-input-group prepend="الجوال">
                    <b-form-input />
                    <b-input-group-append is-text>
                      <feather-icon
                        icon="PhoneCallIcon"
                        color="#2E5D67"
                        size="20"
                      />
                    </b-input-group-append>
                  </b-input-group>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-actions pt-1">
            <button class="btn px-4 btn--gradient-orange" @click="hideModal">
              تعديل
            </button>
            <button class="btn px-4 btn--gradient-green" @click="hideModal">
              حفظ بيانات المنتج
            </button>
            <button class="btn px-4 btn--gray ml-1" @click="hideModal">
              الغاء
            </button>
          </div>
        </b-tab>
        <!-- end tab 3 -->
      </b-tabs>
    </div>
  </b-modal>
</template>

<script>
import {
  BModal,
  BFormSelect,
  BInputGroup,
  BFormInput,
  BInputGroupPrepend,
  BInputGroupAppend,
  BFormTags,
  BTab,
  BTabs,
  BFormDatepicker,
  BFormCheckbox,
  BFormRadio,
} from "bootstrap-vue";
import { quillEditor } from "vue-quill-editor";
import draggable from "vuedraggable";
import vSelect from "vue-select";
export default {
  name: "ProductFormModal",
  components: {
    BModal,
    BFormSelect,
    BInputGroup,
    BFormInput,
    BInputGroupPrepend,
    BInputGroupAppend,
    BFormTags,
    BTab,
    BTabs,
    BFormDatepicker,
    BFormCheckbox,
    BFormRadio,
    quillEditor,
    draggable,
    vSelect,
  },
  data() {
    return {
      options: [
        { value: null, text: "اختر", disabled: true },
        { value: "a", text: "option 1" },
        { value: "b", text: "option 2" },
      ],
      tags: [],
      gallery: [],
      tabIndex: 0,
      fixedQuantity: true,
      requireShipping: true,
      activeGeoService: true,
      activeAdmin: true,
      snowOption: {
        theme: "snow",
        modules: {
          toolbar: true,
        },
      },
      selected: [],
      selected2: [],
    };
  },
  methods: {
    hideModal() {
      this.$bvModal.hide("product-form-modal");
    },
  },
  created() {
    for (let i = 1; i <= 5; i++) {
      this.gallery.push(`https://picsum.photos/100/100?random=${i}`);
    }
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/quill.scss";
@import "@core/scss/vue/libs/vue-select.scss";

/* rtl:ignore */
.ltr-editor .ql-editor {
  direction: ltr;
  text-align: left;
}

/* rtl:ignore */
.rtl-editor .ql-editor {
  direction: rtl;
  text-align: right;
}
</style>
